import React from "react";
import { Navigate } from "react-router-dom";
import { tenantCapabilityWithFallback } from "../../app/auth/tenantCapabilitiesRead";
import { useAuth } from "../../app/auth/useAuth";
import { useI18n } from "../../app/i18n/useI18n";
import { NavCardGrid,type NavCardGroup } from "../../components/NavCardGrid";
import { reportIcon } from "./reportIcons";
import { reportsCatalogGroups } from "./reportsCatalog";
import { ARTICLE_SALES_REPORT_PATH, REPORT_GROUP_LABEL_CALENDAR, REPORT_GROUP_LABEL_LEADS } from "./components/reportValues";

export function ReportsHomePage() {
  const { text } = useI18n();
  const auth = useAuth();

  const rawCaps = auth.info?.capabilities;
  const hasCalendar = tenantCapabilityWithFallback(rawCaps, "calendar", auth.info?.moduleCalendarEnabled ?? false);
  const hasLeadManager = tenantCapabilityWithFallback(rawCaps, "leadManager", auth.info?.moduleLeadManagerEnabled ?? false);
  const hasReports = tenantCapabilityWithFallback(rawCaps, "reports", true);
  const hasArticleSales = tenantCapabilityWithFallback(rawCaps, "articleSales", false);

  // Nur Gruppen anzeigen, für die der Nutzer mindestens eine Berechtigung hat (wie Menü/Router).
  const visibleGroups: NavCardGroup[] = reportsCatalogGroups
    .filter((g) => {
      if (!hasReports) return false;
      if (g.labelKey === REPORT_GROUP_LABEL_CALENDAR && !hasCalendar) return false;
      if (g.labelKey === REPORT_GROUP_LABEL_LEADS && !hasLeadManager) return false;
      if (!g.requiredPermissions?.length) return true;
      return auth.hasAnyPermission(...(g.requiredPermissions ?? []));
    })
    .map((g) => ({
      titleKey: g.labelKey,
      items: (g.items || [])
        .filter((item) => item.path !== ARTICLE_SALES_REPORT_PATH || hasArticleSales)
        .map((item) => ({
          titleKey: item.labelKey,
          icon: reportIcon(item.iconKey),
          descriptionKey: item.description,
          path: item.path
        }))
    }))
    .filter((g) => (g.items || []).length > 0);

  if (visibleGroups.length === 0) return <Navigate to="/forbidden" replace />;

  return (
    <NavCardGrid title={text("Reports")} groups={visibleGroups} text={text} />
  );
}









